export interface CollectionItemData {
  name: string;
  id?: number;
  svg?: string;
  svgs?: string[];
  count?: number;
  answer?: string;
}

export const parseCollectionItems = (
  description: string | undefined | null,
): CollectionItemData[] => {
  if (!description) {
    return [];
  }

  try {
    let parsed: unknown = JSON.parse(description);
    if (typeof parsed === "string") {
      parsed = JSON.parse(parsed);
    }

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.map((item) => {
      if (typeof item === "object" && item !== null) {
        const record = item as Record<string, unknown>;
        return {
          name: typeof record.name === "string" ? record.name : String(item),
          id: typeof record.id === "number" ? record.id : undefined,
          svg: typeof record.svg === "string" ? record.svg : undefined,
          svgs: Array.isArray(record.svgs)
            ? record.svgs
                .filter(
                  (value): value is string =>
                    typeof value === "string" && value.trim().length > 0,
                )
                .slice(0, 2)
            : undefined,
          count: typeof record.count === "number" ? record.count : undefined,
          answer:
            typeof record.answer === "string"
              ? record.answer
              : typeof record.answer === "number"
                ? String(record.answer)
                : undefined,
        };
      }
      return { name: String(item) };
    });
  } catch {
    return [];
  }
};
